/**
 * Redirects from cart page to homepage and opens cart drawer
 * This prevents users from landing on the cart page directly
 */

// On homepage, check if we should open cart drawer
if (window.location.search.includes('open_cart=true')) {
  // Wait for cart drawer component to be defined
  customElements.whenDefined('cart-drawer-component').then(() => {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      // Open the cart drawer
      cartDrawer.open();
      
      // Clean up URL by removing the query parameter
      const url = new URL(window.location.href);
      url.searchParams.delete('open_cart');
      window.history.replaceState({}, '', url.toString());
    }
  });
}
